<template>
  <el-container class='login-container'>
    <div class='login-form'>
      <div class='login-title'>登录</div>
      <el-form ref='form' :model='form' :rules='rules' label-width='80px'>

        <el-form-item label='用户名' prop='userName'>
          <el-input v-model='form.userName' placeholder='请输入用户名' prefix-icon='el-icon-s-custom' @keyup.enter.native='submitForm'></el-input>
        </el-form-item>

        <el-form-item label='密码' prop='password'>
          <el-input v-model='form.password' placeholder='请输入密码' prefix-icon='el-icon-lock' type="password" @keyup.enter.native='submitForm'></el-input>
        </el-form-item>
      </el-form>
      <div style='text-align: center;'>
        <el-button type='primary' style='width: 200px;margin-top: 40px;' @click='submitForm'>登录</el-button>
      </div>
    </div>
    <div style="position:fixed;bottom:0;line-height: 50px;text-align:center;width: 100%;"><a href="http://beian.miit.gov.cn/" target="_blank" style="color: #fff;text-decoration:none;text-align: center;">京ICP备14004444号-5</a></div>
  </el-container>
</template>

<script>

let that

export default {

  data(){
    return {
      form:{
        userName:'',
        password:''
      },
      rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },


  beforeCreate () {
    let manager = JSON.parse(sessionStorage.getItem('manager'))
    if (manager) {
      this.globalData.manager = manager
      this.$router.push('/home')
    }
  },

  methods: {
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          that.api.manager.login(that.form).then(res => {
            let r = res.data
            if(typeof(r) === 'string') {
              this.$message.error(r);
            }else{
              sessionStorage.setItem('manager', JSON.stringify(r))
              this.$router.push('/home/')
              this.globalData.manager = r
            }
          })
        }
      })
    }
  },

  mounted () {
    that = this
  }
}
</script>

<style>
.login-container {
  height: 100%;
  background-image: url(../../assets/imgs/bg-01.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.login-form {
  width: 500px;
  height: 350px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 24px;
  margin-top: -70px;
}

.login-title {
  font-family: 'Microsoft Yahei';
  font-size: 39px;
  color: #333333;
  line-height: 1.2;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
</style>
